import { BuildingOffice2Icon } from '@heroicons/react/24/solid';
import { WfWorkplace } from 'src/api/wf/models/WfWorkplace';
import Button from '../../common/button/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type WorkplaceLike = WfWorkplace | null;

type SiteHeaderProps = {
  workplace: WorkplaceLike;
};

export function SiteHeader({ workplace }: SiteHeaderProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <header>
      <div className="flex flex-col items-start gap-4 border-b pb-4 md:flex-row md:items-center">
        <BuildingOffice2Icon className="size-10 shrink-0 text-gray-500 md:size-14" />
        <div className="flex flex-col justify-center">
          <p className="text-sm text-gray-500">{t('wf.siteDetails.workSite')}</p>
          <h1 className="break-all text-lg font-bold md:text-xl">{workplace?.name}</h1>
        </div>
      </div>
      <div className="flex flex-row items-center justify-between py-2">
        <h2 className="border-l-4 border-blue-600 ps-3 text-base font-semibold">
          {t('wf.siteDetails.worksiteDetails')}
        </h2>
        <div className="flex space-x-2">
          <Button
            title={t('wf.common.back')}
            onClick={() => {
              navigate(-1);
            }}
          />
        </div>
      </div>
    </header>
  );
}
